import {
  DataModuleVO,
  DataPageLimit,
  DataWorkshopEntity,
  DataWorkshopEntityId,
  DataQueryParamWorkshopName,
  DataQueryParamFrom,
  DataQueryParamTo,
} from '@edgvr-front/data/domain';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getSelectors } from '@ngrx/router-store';
import {
  DATA_WORKSHOPS_FEATURE_KEY,
  DataWorkshopsState,
  dataWorkshopsAdapter,
} from '../reducers';

const dataWorkshopsState = createFeatureSelector<DataWorkshopsState>(
  DATA_WORKSHOPS_FEATURE_KEY
);

const { selectAll } = dataWorkshopsAdapter.getSelectors();
const { selectQueryParams } = getSelectors();

export const dataWorkshops = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) =>
    selectAll(state).map((_) => DataWorkshopEntity.factory(_))
);

export const dataWorkshop = (id: DataWorkshopEntityId) =>
  createSelector(dataWorkshopsState, (state: DataWorkshopsState) => {
    const dataWorkshopRaw = state.entities[id];

    return dataWorkshopRaw ? DataWorkshopEntity.factory(dataWorkshopRaw) : null;
  });

export const selectedDataWorkshop = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) =>
    state.selectedDataWorkshop
      ? DataWorkshopEntity.factory(state.selectedDataWorkshop)
      : state.selectedDataWorkshop
);

export const selectedDataModule = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) =>
    state.selectedDataModule
      ? DataModuleVO.factory(state.selectedDataModule)
      : state.selectedDataModule
);

export const count = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => state.count
);
export const from = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => (state.page - 1) * DataPageLimit
);
export const to = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => state.page * DataPageLimit
);

export const page = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => state.page
);
export const prevPage = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => (state.page > 1 ? state.page - 1 : 0)
);
export const nextPage = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) =>
    state.page * DataPageLimit < state.count ? state.page + 1 : 0
);

export const loading = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => state.loading
);

export const loaded = createSelector(
  dataWorkshopsState,
  (state: DataWorkshopsState) => state.loaded
);

export const routerWorkshopName = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamWorkshopName]
);
export const routerFrom = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamFrom]
);
export const routerTo = createSelector(
  selectQueryParams,
  (queryParams) => queryParams[DataQueryParamTo]
);
